


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Navbar from './Navbar';
import InfluencerHeader from './InfluencerHeader';

const RaiseComplaintInfluencers = () => {
  const [influencerData, setInfluencerData] = useState({});
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInfluencerData = async () => {
      try {
        const userId = localStorage.getItem("influencerID");
        if (!userId) {
          console.log("Influencer ID not found in localStorage");
          return;
        }

        const res = await fetch(`https://server-side-influencer.onrender.com/influencer/getInfluencer/${userId}`);
        const result = await res.json();
        setInfluencerData(result.data);
      } catch (err) {
        console.error("Failed to fetch influencer data:", err);
        toast.error("Failed to load influencer data");
      }
    };

    fetchInfluencerData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      influencerName: influencerData?.fullname,
      influencerEmail: influencerData?.email,
      subject,
      message,
    };

    try {
      const userId = localStorage.getItem("influencerID");
      const res = await fetch(`https://server-side-influencer.onrender.com/influencer/influencercomplaint/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (!res.ok || !result.success) {
        throw new Error(result.message || 'Submission failed');
      }

      toast.success("Your complaint submitted successfully!");
      setSubject('');
      setMessage('');
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Something went wrong while submitting.");
    }
  };

  return (
    <div className="flex h-screen overflow-y-auto">
      {/* Header */}
      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <InfluencerHeader page="complaint" />
      </div>

      {/* Navbar */}
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-1 ml-10 mt-20 mb-10 w-full px-6">
        {/* Top Button */}
        <div className="flex justify-end items-center mt-4 mr-10">
          <button
            type="button"
            className="mt-2 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2"
            onClick={() => navigate('/influencersumitted')}
          >
            Submitted Complaints
          </button>
        </div>

        {/* Complaint Form */}
        <h2 className="text-3xl font-semibold text-center mt-10">Register your complaint here</h2>
        <div className="flex justify-center items-center mt-6">
          <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-2xl">
            <form onSubmit={handleSubmit}>
              <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="subject">
                Subject
              </label>
              <input
                type="text"
                id="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="w-full p-3 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter subject"
                required
              />

              <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="message">
                Message
              </label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full h-40 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Write your complaint here..."
                required
              />

              <button
                type="submit"
                className="mt-4 w-full text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Toast Notifications */}
      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
};

export default RaiseComplaintInfluencers;
